
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/posts/2019-08-10-when-is-golden-hour-updates",
      function () {
        return require("private-next-pages/posts/2019-08-10-when-is-golden-hour-updates.md");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/posts/2019-08-10-when-is-golden-hour-updates"])
      });
    }
  